import tagsService from '../../services/tagsService'

class TagsController {
  fetchAllTags = tagsService.fetchAllTags
}

export default new TagsController()
 


// WEBPACK FOOTER //
// ../src/controllers/tagsController/tagsController.js